<template>
  <div>
    <h2 class="mb-5">{{ defaultHeader }}</h2>

    <div class="row flex-row mt-4">
      <div class="d-flex col-12 col-lg-6">
        <RentalObjectRentalObject class="flex-fill" :rentalObjectId="rentalObjectId" />
      </div>

      <div class="d-flex col-12 col-lg-6 mt-5 mt-lg-0">
        <RentalObjectProperty class="flex-fill" :rentalObjectId="rentalObjectId" />
      </div>
    </div>

    <div class="row flex-row mt-4">
      <div class="d-flex col-12 col-lg-6">
        <RentalObjectRules class="flex-fill" :rentalObjectId="rentalObjectId" />
      </div>

      <div class="col-12 col-lg-6">
        <RentalObjectMeterVerification :rentalObjectId="rentalObjectId" />

        <RentalObjectFacilities class="flex-fill mt-4" :rentalObjectId="rentalObjectId" />
      </div>
    </div>

    <div class="mt-4 col-13">
      <RentalObjectRooms :rentalObjectId="rentalObjectId" />
    </div>

    <div class="row flex-row mt-4">
      <div class="d-flex col-12">
        <RentalObjectHide class="flex-fill" :landlordId="landlordId" :rentalObjectId="rentalObjectId" />
      </div>
    </div>
  </div>
</template>

<script>
import RentalObjectFacilities from '@/components/detailedRentalObject/RentalObjectFacilities.vue';
import RentalObjectProperty from '@/components/detailedRentalObject/RentalObjectProperty.vue';
import RentalObjectRentalObject from '@/components/detailedRentalObject/RentalObjectRentalObject.vue';
import RentalObjectRooms from '@/components/detailedRentalObject/RentalObjectRooms.vue';
import RentalObjectRules from '@/components/detailedRentalObject/RentalObjectRules.vue';
import RentalObjectHide from '@/components/detailedRentalObject/RentalObjectHide.vue';
import RentalObjectMeterVerification from '@/components/detailedRentalObject/RentalObjectMeterVerification.vue';

export default {
  props: {
    rentalObjectId: [Number, String],
    landlordId: [Number, String],
    defaultHeader: String,
  },

  components: {
    RentalObjectFacilities,
    RentalObjectProperty,
    RentalObjectRentalObject,
    RentalObjectRooms,
    RentalObjectRules,
    RentalObjectHide,
    RentalObjectMeterVerification,
  },
};
</script>

<style lang="scss">
.pre-responsive {
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: justify;
  font-family: inherit;
  font-size: inherit;
  background: $gray-100;
  padding: 2rem;
  border-radius: $border-radius-medium;
}

.scroll-down {
  border-radius: 0 0 $border-radius-medium $border-radius-medium;
  background-image: linear-gradient(transparent, $gray-400);
  width: 100%;

  position: relative;
  bottom: 55px;
  padding: 10px 0;
  font-size: 0.8rem;
  color: inherit;
}
</style>
